import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
// import detector from 'i18next-browser-languagedetector';
// import LngDetector from 'i18next-browser-languagedetector';

import translationEN from './translation/en.json';
// import translationHIN from './translation/hin.json';
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    /* old
     * en: translationEN,
     * hin: translationHIN,
     */
    en: translationEN,
    hin: translationEN,
    lng:
      localStorage.getItem('changeLanguage') !== null
        ? localStorage.getItem('changeLanguage')
        : 'hin',
    fallbackLng: 'hin',
    debug: false,
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false, // we use content as keys
    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
    },
    react: {
      wait: true,
    },
  });

export default i18n;
